import { render, staticRenderFns } from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=template&id=342309a4"
import script from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=style&index=0&id=342309a4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342309a4')) {
      api.createRecord('342309a4', component.options)
    } else {
      api.reload('342309a4', component.options)
    }
    module.hot.accept("./QuoteBuilderOtherLabourItemTemplate.vue?vue&type=template&id=342309a4", function () {
      api.rerender('342309a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/templates/QuoteBuilderOtherLabourItemTemplate.vue"
export default component.exports